import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class Section extends Component {
    static propTypes = {
        title: PropTypes.any,
        className: PropTypes.string
    }

    static defaultProps = {
        title: null,
    }

    render() {
        return (
            <div className={this.props.className + ' page-section ' + (this.props.collapsed ? 'collapsed' : '')}>
                <div className="page-section__header">
                    {this.props.title}
                </div>
                <div className="page-section__content">
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Layout/Section.jsx